import { isUndefined } from 'lodash/fp';
import React, { useMemo } from 'react';

import { useWindowResize } from '../../../hooks/useWindowResize';
import { Button } from '../../shared/button/Button';
import { PageLoadingDots } from '../../shared/loading-dots/PageLoadingDots';
import { Scrollable } from '../../shared/scrollable/Scrollable';
import { ClientDatasets } from '../client-datasets/store';
import styles from './SharedAdmin.module.scss';
import { DatasetTile } from './DatasetTile';
import GaugeChart from '../../../assets/GaugeChart.png';

interface DatasetsListProps {
    datasets: ClientDatasets[];
    header: string;
    isLoading: boolean;
    openPreview?: (datasetId: number) => void;
    openConfigure?: (datasetId: number) => void;
    openRiskTolerance?: (datasetId: number) => void;
    backToDatasetTable?: () => void;
    selectDataset?: (datasetId: number) => void;
}

export const DatasetsList: React.FC<DatasetsListProps> = ({ datasets, header, isLoading, openPreview, openConfigure, openRiskTolerance, backToDatasetTable, selectDataset }) => {
    const [, screenHeight] = useWindowResize();
    const resultsHeight = useMemo(() => screenHeight - 240, [screenHeight]);

    if (isLoading) {
        return <PageLoadingDots />;
    }

    return (
        <div className={styles.datasetListWrapper} data-testid='dataset-list-wrapper'>
            <div className={styles.datasetsTitleContainer}>
                <div className={styles.datasetsHeader} data-testid='dataset-list-header'>{header}</div>
                {!isUndefined(backToDatasetTable) && <Button label='Back' onClick={backToDatasetTable} />}
                {!isUndefined(openRiskTolerance) && <img className={styles.gaugeChart} src={GaugeChart} />}
            </div>
            <div className={styles.datasetList} data-testid='dataset-list-results-wrapper' style={{ height: `${resultsHeight}px` }}>
                <Scrollable>
                    <div className={styles.tilesWrapper}>
                        {datasets.map(({ datasetId, documentNames, agreementType }) => (
                            <DatasetTile
                                key={datasetId}
                                datasetId={datasetId}
                                documentNames={documentNames}
                                agreementType={agreementType}
                                preview={!isUndefined(openPreview) ? () => openPreview(datasetId) : undefined}
                                configure={!isUndefined(openConfigure) ? () => openConfigure(datasetId) : undefined}
                                riskTolerance={!isUndefined(openRiskTolerance) ? () => openRiskTolerance(datasetId) : undefined}
                                selectDataset={!isUndefined(selectDataset) ? () => selectDataset(datasetId) : undefined}
                            />
                        ))}
                    </div>
                </Scrollable>
            </div>
        </div>
    );
};

